<mat-toolbar color="accent">Invite Users</mat-toolbar>

<mat-dialog-content>
  <form #form class="flex flex-col gap-4" [formGroup]="inviteForm">
    <div class="mb-2 flex flex-row items-stretch gap-2">
      <mat-form-field
        class="flex-1"
        subscriptSizing="dynamic"
        floatLabel="always"
      >
        <mat-label>Emails</mat-label>
        <input
          matInput
          formControlName="emails"
          placeholder="Invite users by email (comma separated accepted)"
          (keydown.enter)="addEmails()"
        />
      </mat-form-field>

      <button
        type="button"
        color="primary"
        mat-stroked-button
        (click)="addEmails()"
      >
        Add
      </button>
    </div>

    @if (usersArray.controls.length) {
      <div formArrayName="users" class="flex flex-col gap-4">
        <mat-list>
          @for (
            control of usersArray.controls;
            track control.value?.email;
            let index = $index
          ) {
            <mat-list-item>
              <div
                class="flex flex-1 flex-row items-start justify-between gap-4 py-2"
                [formGroupName]="index"
              >
                <mat-form-field class="w-[200px]" subscriptSizing="dynamic">
                  <mat-label>Name</mat-label>
                  <input type="text" matInput formControlName="name" />
                </mat-form-field>

                <mat-form-field class="w-[240px]" subscriptSizing="dynamic">
                  <mat-label>Email</mat-label>
                  <input
                    type="email"
                    matInput
                    formControlName="email"
                    [disabled]="true"
                  />
                </mat-form-field>

                @if (roles$ | async; as roles) {
                  <mat-form-field class="w-[200px]" subscriptSizing="dynamic">
                    <mat-label>Roles</mat-label>
                    <mat-select formControlName="roles" multiple>
                      @for (role of roles; track role.ref.path) {
                        <mat-option [value]="role.ref">
                          {{ role.name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }

                @if (
                  (hasMultiplePractices$ | async) && (practices$ | async);
                  as practices
                ) {
                  <mat-form-field class="w-[200px]" subscriptSizing="dynamic">
                    <mat-label>Practices</mat-label>
                    <mat-select formControlName="practices" multiple>
                      @for (practice of practices; track practice.ref.path) {
                        <mat-option [value]="practice.ref">
                          {{ practice.name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }

                <div class="mt-1 flex w-[40px] flex-row justify-end">
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    matTooltip="Remove user"
                    (click)="removeEmail(index)"
                  >
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </div>
              </div>
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container class="flex-1" padding="none">
    <pt-loader-button
      type="stroked"
      color="primary"
      [loading]="loading$ | async"
      [disabled]="isDisabled$ | async"
      (click)="submit()"
    >
      Invite
    </pt-loader-button>
  </pt-buttons-container>
</mat-dialog-actions>
